import { Matricula } from '../Domain/Matricula'
import { VehiculoRepository } from '../Domain/VehiculoRepository'
import { Vehicle } from '../../../../../common/types/Vehiculo'

export class BuscarVehiculoPorMatricula {
  private readonly vehiculoRepo: VehiculoRepository
  constructor(vehiculoRepo: VehiculoRepository) {
    this.vehiculoRepo = vehiculoRepo
  }

  async execute(matricula: Matricula): Promise<Vehicle[] | null> {
    const vehiculos = await this.vehiculoRepo.obtenerPorMatricula(matricula)
    if (!vehiculos || vehiculos.length === 0) return null
    return vehiculos
  }
}
